
import { Route } from 'react-router-dom';
import { lazy } from 'react';

// Import core pages directly (no lazy loading)
import Home from '@/pages/homepage/home/Home';
import Radex from '@/pages/homepage/home/Radex';
import ReferralOpportunity from '@/pages/homepage/home/ReferralOpportunity';
import SignUp from '@/pages/homepage/auth/SignUp';
import SignIn from '@/pages/homepage/auth/SignIn';
import ContactUs from '@/pages/homepage/home/ContactUs';
import ContactMe from '@/pages/homepage/home/ContactMe';
import Strategies from '@/pages/homepage/home/Strategies';
import Tutorials from '@/pages/homepage/Tutorials';

// Lazy load other pages
const ForgotPassword = lazy(() => import('@/pages/homepage/auth/ForgotPassword'));
const ResetPassword = lazy(() => import('@/pages/homepage/auth/ResetPassword'));
const VerifyEmail = lazy(() => import('@/pages/homepage/auth/VerifyEmail'));
const Terms = lazy(() => import('@/pages/homepage/legal/Terms'));
const Privacy = lazy(() => import('@/pages/homepage/legal/Privacy'));
const Cookies = lazy(() => import('@/pages/homepage/legal/Cookies'));
const NotFound = lazy(() => import('@/pages/homepage/home/NotFound'));
const Error = lazy(() => import('@/pages/homepage/home/Error'));

// News pages
const News = lazy(() => import('@/pages/homepage/news/News'));
const NewsDetail = lazy(() => import('@/pages/homepage/news/NewsDetail'));


// Import skeleton loaders
import AuthSkeleton from '@/components/skeletons/AuthSkeleton';
import DashboardSkeleton from '@/components/skeletons/DashboardSkeleton';
import LegalSkeleton from '@/components/skeletons/LegalSkeleton';

// Import utilities
import { createRouteWithLang, withSuspense } from './utils/routeUtils';

export const getPublicRoutes = () => {
  return [
    // Core pages - no lazy loading
    ...createRouteWithLang('/', <Home />),
    ...createRouteWithLang('/radex', <Radex />),
    ...createRouteWithLang('/referral-program', <ReferralOpportunity />),
    ...createRouteWithLang('/contact-us', <ContactUs />),
    ...createRouteWithLang('/contact-me', <ContactMe />),
    ...createRouteWithLang('/strategies', <Strategies />),
    ...createRouteWithLang('/tutorials', <Tutorials />),

    // News pages
    ...createRouteWithLang('/news', withSuspense(News, DashboardSkeleton)),
    ...createRouteWithLang('/news/:slug', withSuspense(NewsDetail, DashboardSkeleton)),

    // Authentication routes
    ...createRouteWithLang('/sign-up', <SignUp />),
    ...createRouteWithLang('/sign-in', <SignIn />),

    // Auth pages with skeleton
    ...createRouteWithLang('/forgot-password', withSuspense(ForgotPassword, AuthSkeleton)),
    ...createRouteWithLang('/reset-password', withSuspense(ResetPassword, AuthSkeleton)),
    ...createRouteWithLang('/verify-email', withSuspense(VerifyEmail, AuthSkeleton)),


    // Legal routes with skeleton
    ...createRouteWithLang('/terms', withSuspense(Terms, LegalSkeleton)),
    ...createRouteWithLang('/privacy', withSuspense(Privacy, LegalSkeleton)),
    ...createRouteWithLang('/cookies', withSuspense(Cookies, LegalSkeleton)),

    // Error route
    ...createRouteWithLang('/error', withSuspense(Error, DashboardSkeleton)),

    // 404 route - must be last to catch all unmatched routes
    <Route key="not-found" path="*" element={withSuspense(NotFound, () => <div className="min-h-screen bg-gray-100 dark:bg-gray-900" />)} />
  ];
};
